import styles from './Callout.module.scss'

const Root = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.card}>{children}</div>
}

const Header = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.header}>{children}</div>
}

const Title = ({ children }: { children: React.ReactNode }) => {
  return <p className={styles.cardTitle}>{children}</p>
}

const Description = ({ children }: { children: React.ReactNode }) => {
  return <p className={styles.cardDescription}>{children}</p>
}

export const Callout = {
  Root,
  Header,
  Title,
  Description,
}
